import { all } from 'redux-saga/effects';

import {getDailyReportSagaWatcher} from './get_daily_report.saga'
import { getDayOfWeekReportSagaWatcher } from './get_dayofweek_report.saga'
import { getProductSalesReportSagaWatcher } from './get_productsales_report.saga'


export default function* reportSaga() {
    yield all([
        getDailyReportSagaWatcher(),
        getDayOfWeekReportSagaWatcher(),
        getProductSalesReportSagaWatcher()
    ]);
}